module.exports = __webpack_public_path__ + "static/media/SFProText-SemiboldItalic.5f7b2454.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProText-SemiboldItalic.ttf
// module id = 2553
// module chunks = 7